/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const topOvalComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('TopOval').attach(memoEval((self)=>[
            self.$objectName
        ], ($objectName)=>({
            fileUrl: '/models/algu3d.glb',
            objectName: $objectName,
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('TopOval').attach(memoEval((self)=>[
            self.length,
            self.width,
            self.thickness,
            self.$edgeFinishFacet,
            self.$edgeFinishRound
        ], (length, width, thickness, $edgeFinishFacet, $edgeFinishRound)=>({
            morphTargetInfluences: {
                Length: {
                    value: length,
                    scaleOne: 3000,
                    scaleZero: 1600
                },
                Width: {
                    value: width,
                    scaleOne: 1300,
                    scaleZero: 800
                },
                Depth: {
                    value: thickness,
                    scaleOne: 60,
                    scaleZero: 12
                },
                Facet: {
                    value: $edgeFinishFacet,
                    scaleOne: 1,
                    scaleZero: 0
                },
                Bol: {
                    value: $edgeFinishRound,
                    scaleOne: 1,
                    scaleZero: 0
                }
            }
        })))
];

//# sourceMappingURL=top-oval.js.map